import get from 'lodash/get';
import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { translationMessages } from 'store/LanguageProvider/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { changeLocaleLanguage } from './actions';

const messages = translationMessages;

interface LanguageProviderProps {
  locale: string;
}

const LanguageProvider: React.FC<LanguageProviderProps> = (
  props,
): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    const locale = localStorage.getItem('locale');
    if (locale) {
      /* istanbul ignore next */
      dispatch(changeLocaleLanguage(locale));
    }
  }, [dispatch]);
  return (
    <IntlProvider locale={props.locale} messages={get(messages, props.locale)}>
      {React.Children.only(props.children)}
    </IntlProvider>
  );
};

const mapStateToProps = createStructuredSelector({
  locale: getLocaleSelector,
});

export default connect(mapStateToProps)(LanguageProvider);
